import Button from "@/components/library/Buttons/Button";
import Input from "@/components/library/Inputs/Input";
import { ButtonType } from "@/types/library/Buttons";
import { InputType } from "@/types/library/Inputs";

const OTP = ({ vm }) => {
  return (
    <div>
      <span className="font-bold text-lg text-white ">{vm.labels.title}</span>

      <Input
        id="code"
        inputType={InputType.Text}
        placeholder={vm.labels.codePlaceholder}
        customRef={vm.OTPRef}
        value={vm.OTPRef?.current?.value}
        onChange={() => {}}
      />
      <div className="flex items-center justify-end">
        <Button
          buttonType={ButtonType.Secondary}
          text={vm.labels.backButtonText}
          id="back-button"
          width=""
          onClick={vm.onBackButtonHandler}
        />
        <Button
          buttonType={ButtonType.Primary}
          isSubmitButton
          id="login-otp-button"
          text={vm.labels.loginButtonText}
          width=""
          onClick={vm.OTPLoginButtonClick}
        />
      </div>
    </div>
  );
};

export default OTP;
